import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;

  .proposal-main {
    min-width: 0;
  }

  .proposal-target-highlight {
    outline: 3px solid #ffc107;
    outline-offset: 2px;
    transition: outline-color 0.3s;
  }

  tr.proposal-target-highlight td {
    background-color: #fff3cd;
  }

  .proposal-main,
  .proposal-scroll {
    background: #fff;
  }

  .proposal-scroll {
    flex: 1;
    min-height: 0;
  }

  .missing-card {
    border: 1px solid #ffc107;
    border-radius: 8px;
    background: #fff;
    padding: 16px 20px;
    margin-bottom: 16px;

    h3 {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 16px;
      font-weight: 600;
      color: #856404;
      margin-bottom: 8px;

      .material-icons-outlined {
        font-size: 20px;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 8px 0;
      border-top: 1px solid #e9ecef;
      color: #21354a;
    }
  }

  .proposal-footer-bar {
    flex-shrink: 0;
    height: 64px;
    padding: 10px 24px;
    border-top: 1px solid ${(props) => props.theme.$gray300};
    background: #fff;
  }

  .page-head h1 {
    font-size: 24px;
    line-height: 1.2;
    font-weight: 500;
    color: #21354a;
    margin: 0;
  }

  .page-head .subtitle {
    font-size: 13px;
    color: #6c757d;
    margin: 6px 0 0;
  }

  .edict-check {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin: 12px 0 0;
    font-size: 13px;
    color: #495057;

    > .material-icons-outlined {
      font-size: 17px;
      color: #6c757d;
    }

    button {
      border: 0;
      background: transparent;
      color: #007bff;
      display: inline-flex;
      align-items: center;
      gap: 3px;
      padding: 0 4px;
      font-size: 13px;

      .material-icons-outlined {
        font-size: 15px;
      }
    }
  }

  .step-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 16px 0 16px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;

    h2 {
      font-size: 18px;
      font-weight: 500;
      color: #21354a;
      margin: 0;
    }

    small {
      display: block;
      margin-top: 2px;
      font-size: 13px;
      color: #6c757d;
    }
  }

  .step-toolbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;

    > .btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      color: #21354a;
      border-color: #ced4da;
      background: #fff;
      font-weight: 500;
    }

    .material-icons-outlined {
      font-size: 18px;
    }
  }

  .autosave {
    color: #6c757d;
    font-size: 13px;
    display: flex;
    gap: 6px;
    align-items: center;

    .material-icons-outlined {
      font-size: 18px;
    }
  }

  .autosave-spinner {
    width: 12px;
    height: 12px;
    border: 2px solid #dee2e6;
    border-top-color: #007bff;
    border-radius: 50%;
    animation: proposal-spin 0.7s linear infinite;
  }

  @keyframes proposal-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .footer-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    .footer-step-actions {
      display: contents;
    }

    .footer-hint {
      order: -1;
      max-width: 260px;
      line-height: 1.25;
      text-align: right;
      font-size: 13px;
      color: #6c757d;
    }

    > small {
      max-width: 260px;
      line-height: 1.25;
      text-align: right;
      margin-right: 5px;
      font-size: 13px;
      color: #6c757d;
    }
  }

  .proposal-status {
    border: 1px solid ${(props) => props.theme.$gray300};
    font-weight: 600;
  }

  .proposal-empty {
    max-width: 900px;
    border-color: ${(props) => props.theme.$gray300};
  }

  .proposal-empty-title {
    color: ${(props) => props.theme.$dark};
    font-size: 18px;
    font-weight: 600;
  }

  .analyst-link {
    vertical-align: baseline;

    .material-icons-outlined {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
`;
